if (!customElements.get('pagination-enhanced')) {
  customElements.define(
    'pagination-enhanced',
    class Pagination extends HTMLElement {
      constructor() {
        super()
        this.init()
      }
      setListeners() {
        this.querySelectorAll('a').forEach((link) => {
          link.addEventListener('click', (e) => {
            e.preventDefault()
            this.renderHTML(link.getAttribute('href'))
          })
        })
      }
      renderHTML(url) {
        fetch(url, {})
          .then((response) => response.text())
          .then((text) => {
            const newPageHTML = new DOMParser().parseFromString(
              text,
              'text/html'
            )
            const ProductGrid = newPageHTML.getElementById('GridContainer')
            const ProductGridTarget = document.getElementById('GridContainer')
            if (ProductGrid.innerHTML && ProductGridTarget.innerHTML) {
              ProductGridTarget.innerHTML = ProductGrid.innerHTML
            }
            const PaginationEnhanced = newPageHTML.querySelector(
              'pagination-enhanced'
            )
            const PaginationEnhancedTarget = document.querySelector(
              'pagination-enhanced'
            )
            if (
              PaginationEnhanced.outerHTML &&
              PaginationEnhancedTarget.outerHTML
            ) {
              PaginationEnhancedTarget.outerHTML = PaginationEnhanced.outerHTML
            }
          })
          .then(() => {
            window.history.pushState(null, '', url)
            window.scrollTo({
              top: document.getElementById('GridContainer').offsetTop - 150,
              left: 0,
              behavior: 'smooth',
            })
          })
      }
      init() {
        this.setListeners()
      }
    }
  )
}
